import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PlusCircle as PlusCircleIcon } from 'react-feather'
import { Paper, TablePagination, Hidden, Button } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  FilterButton,
  LoadingFeedback,
  Page,
  Permitted,
  Filters,
} from 'components'
import { PdcaTable } from './components'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'

import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'

const PdcaMain = () => {
  const [loading, setLoading] = useState(false)

  const filter = useFilter()
  const history = useHistory()

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.pdca.list,
    { perPage, page, ...filter.filters },
    [perPage, page, filter.filters],
  )

  const handleRedirect = () => history.push(routes.pdca.new)

  return (
    <Page title="PDCA">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoading || loading} />
        <ContentHeader title="PDCA">
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_PDCA.MANAGE}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={handleRedirect}
              fullWidth
            >
              Criar
            </Button>
          </Permitted>
          <FilterButton
            setDrawerOpen={filter.setDrawerOpen}
            isLoading={isLoading}
          />
        </ContentHeader>
        <Paper variant="outlined">
          <PdcaTable
            refresh={refresh}
            setLoading={setLoading}
            dataPdcas={response?.data?.monitoringManagementPdcas || []}
            loading={loading}
          />
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 15, 20]}
            labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Paper>
        <Filters filter={filter} alphabeticalOrder>
          <input textfieldinput="true" label="Identificador" name="id" />
          <input textfieldinput="true" label="Nome" name="nameCont" />
          <input textfieldinput="true" label="Origem" name="originCont" />
          <input
            datepickerinput="true"
            label="Data de Ínicio maior que"
            name="startDateGteq"
          />
          <input
            datepickerinput="true"
            label="Data de Ínicio menor que"
            name="startDateLteq"
          />
          <input
            datepickerinput="true"
            label="Data final maior que"
            name="endDateGteq"
          />
          <input
            datepickerinput="true"
            label="Data final menor que"
            name="endDateLteq"
          />
        </Filters>
      </Container>
    </Page>
  )
}

export default PdcaMain
